import AxiosInstance from '../config/AxiosInstance';

const getGroupTax = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/taxgroups/list', {
            params: {
                page: payload.page,
                limit: payload.limit,
                searchValue: payload.searchValue,
                sort: payload.sort,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const createGroupTax = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/taxgroups', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateGroupTax = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/taxgroups/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteGroupTax = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/taxgroups/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailGroupTax = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/taxgroups/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getTax = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/taxes/list', {
            params: {
                page: payload.page,
                limit: payload.limit,
                searchValue: payload.searchValue,
                sort: payload.sort,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const createTax = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/taxes', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateTax = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/taxes/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteTax = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/taxes/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailTax = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/taxes/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createGroupTax,
    getGroupTax,
    updateGroupTax,
    deleteGroupTax,
    getDetailGroupTax,
    createTax,
    getTax,
    updateTax,
    deleteTax,
    getDetailTax,
}